// Copyright (c) 2020 by Audere
//
// Use of this source code is governed by an LGPL-3.0 license that
// can be found in the LICENSE file distributed with this file.

import "firebase/storage";

import React, {
  CSSProperties,
  ImgHTMLAttributes,
  useEffect,
  useState,
} from "react";
import { Theme, createStyles, makeStyles } from "@material-ui/core";

import firebase from "firebase/app";

const useStyle = makeStyles((theme: Theme) =>
  createStyles({
    serverAsset: {
      display: "inline-block",
    },
  })
);

export interface ServerAssetImageProps
  extends ImgHTMLAttributes<HTMLImageElement> {
  alt: string; // make it mandatory.
  // Width and height are mandatory so that the image space in the UI is reserved.
  // Without this, the UI would jump while the image is being loaded.
  width: number;
  height: number;
}

export default (props: ServerAssetImageProps) => {
  const [url, setUrl] = useState<string | undefined>(undefined);
  const { src, alt, width, height, ...rest } = props;
  const classes = useStyle();

  useEffect(() => {
    async function getImageUrl() {
      const firestoreUrl = await firebase
        .storage()
        .ref(`assets/${src}`)
        .getDownloadURL();

      setUrl(firestoreUrl);
    }
    getImageUrl();
  });

  if (url) {
    return <img src={url} alt={alt} width={width} height={height} {...rest} />;
  } else {
    const style = {
      width: `${width}px`,
      height: `${height}px`,
    } as CSSProperties;
    return <div className={classes.serverAsset} style={style} />;
  }
};
